/* eslint-disable */


/**
 * Create styles for `<SpeedDialWrapper />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<SpeedDialWrapper />` styles
 */
const speedDialWrapperStyles = ({ theme }) => ({
  backDrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
  speedDial: {
    [theme.breakpoints.up(`lg`)]: {
      bottom: theme.spacing(1) * 4,
      right: theme.spacing(1) * 4,
    },
    bottom: theme.spacing(1) * 3,
    position: `absolute`,
    right: theme.spacing(1) * 3,
    zIndex: theme.zIndex.drawer + 2,
  },
});

export default speedDialWrapperStyles;
